export default __webpack_public_path__ + "static/media/IDSM.9c4f56ca.png";